import { jsx as _jsx } from "react/jsx-runtime";
import { WithSearchPageUseQueryContextProvider } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/ViewState/WithSearchPageUseQueryContextProvider";
import React from "react";
export var WithSearchPageData = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx(WithSearchPageUseQueryContextProvider, {
        children: children
    });
};
